import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, contentChildren, HostBinding, TemplateRef } from '@angular/core';
import { Nullable } from 'primeng/ts-helpers';
import { OspTemplateDirective } from '../../../../directives/osp-template.directive';

@Component({
  selector: 'osp-dialog',
  standalone: true,
  imports: [NgTemplateOutlet],
  templateUrl: './dialog.component.html',
  styleUrl: './dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogComponent {
  @HostBinding('class.osp-dialog') protected hostCssClassEnabled = true;
  static readonly templateNameContent = 'content';
  static readonly templateNameFooter = 'footer';

  $templates = contentChildren(OspTemplateDirective);

  protected $tmplContent = computed(() => this.findTemplate(DialogComponent.templateNameContent));
  protected $tmplFooter = computed(() => this.findTemplate(DialogComponent.templateNameFooter));

  private findTemplate(tmplName: string): TemplateRef<unknown> | Nullable {
    return (this.$templates() || []).find(({ name }) => name === tmplName)?.template;
  }

}
